<template>
	<div>
		<div
			v-if="!resetuser && message"
			class="notification is-light"
			:class="messageType"
		>
			{{ message }}
		</div>
		<div v-if="resetuser && active">
			<div class="content">
				<h1 class="title is-bold">Create a password</h1>
				<p>
					You&rsquo;ll use your email address to log in. If you need to, you can
					change your email address after you've completed registration.
				</p>
			</div>

			<form-user-invite
				v-if="user"
				:fetching="fetching"
				:message="message"
				:message-type="messageType"
				@submit="complete"
			></form-user-invite>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { tokenType } from "../api";

export default {
	name: "AuthUserInvite",
	data() {
		return {
			active: true,
			resetuser: false
		};
	},
	computed: {
		...mapGetters({
			user: "authentication/user",
			fetching: "authentication/fetching",
			message: "authentication/message",
			messageType: "authentication/messageType"
		}),
		userid() {
			return Number(this.$route.params.userid);
		},
		resettoken() {
			return this.$route.params.resettoken;
		},
		details() {
			return {
				userid: this.userid,
				token: this.resettoken,
				type: tokenType.invite
			};
		}
	},
	async created() {
		await this.validate(this.details);
		if (this.user) {
			this.resetuser = true;
			return;
		}
		// If we get here the token doens't work. So lets return them to the login page.
		setTimeout(() => this.$router.push({ name: "Login" }), 2000);
	},
	methods: {
		...mapActions({
			validate: "authentication/validate",
			confirmInvite: "authentication/confirmInvite"
		}),
		async complete(values) {
			const data = { ...this.details, ...values };

			await this.confirmInvite(data);

			setTimeout(() => this.$router.push({ name: "Login" }), 2000);
		}
	}
};
</script>
